import script from "./SoftwareDown.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftwareDown.vue?vue&type=script&setup=true&lang=js"

import "./SoftwareDown.vue?vue&type=style&index=0&id=38304e5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38304e5d"]])

export default __exports__